import React, { useEffect, useState } from "react";
import {
  backBtnBlack,
  eyeClose,
  eyeOpen,
  Logo,

} from "../../assets/img";
import { useNavigate } from "react-router-dom";

import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { useLocation } from "react-router-dom";
import { Toast } from "../../Component/Toast";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../../Component/MaskIcon";

const CreatePassword = () => {
  const location = useLocation();
  const admin_id = location.state?.admin_id;
  const [isLoading, setIsloading] = useState(false);
  const navigate = useNavigate();

  // ✅ Store input values separately from visibility states
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePassword = () => setShowPassword(!showPassword);
  const toggleConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  useEffect(() => {
    const isPasswordValid = password.length >= 4;
    const matches = password == confirmPassword
    setIsFormValid(matches && isPasswordValid);
  }, [password, confirmPassword]);

  const handleConfirm = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      Toast("Please enter both password fields.");
      return;
    }

    if (password !== confirmPassword) {
      Toast("Passwords do not match!");
      return;
    }


    const formdata = {
      admin_id: admin_id,
      password: password,
      password_confirmation: confirmPassword,
    };
    //     console.log(formdata, "formdata")
    setIsloading(true);
    try {
      const res = await post(URLS.CHANGEPASSWORD, formdata);
      //       console.log("Create password response:", res);

      if (res.status === "success") {
        Toast(res.message || "Password created successfully!");
        setIsloading(false);
        navigate("/");
      } else {
        setIsloading(false);
        Toast(res.message || "Failed to create password, try again.");
      }
    } catch (err) {
      console.error("Create password error:", err);
      setIsloading(false);
      Toast("Something went wrong while creating password.");
    } finally {
      setIsloading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="row min-vh-100">
        {/* Left Side Logo */}
        <div className="col-lg-6 d-flex ac-jc login-left">
          <img src={Logo} className="img-fluid logo" alt="Logo" />
        </div>

        {/* Right Side Form */}
        <div className="col-lg-6 login-right">


          <form className="login-form" style={{
            // height: "80%", 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            position: "absolute",
            padding: "0 30px"
          }} onSubmit={handleConfirm}>
            <span style={{ display: "flex", gap: '10px' ,marginBottom:5}} onClick={() => navigate(-1)}>
                          <img
                            className="pointer backinage"
                            src={backBtnBlack}
                            height={18}
                            width={18}
                            style={{ marginTop: '3.5px' }}
                          />
            <h2 style={{ color: 'black', fontSize: 20 }} className="login-title f3 fs-lg-22">
              Create Password
            </h2>
            </span>
            {/* Password Field */}
            <div className="form-group  mt-2">
              <label style={{ color: '#8F0D3d' }} className="form-label f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                Password
              </label>
              <div className="login-input">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="placholdercolorchanges"
                  required
                />
                <span
                  onClick={togglePassword}
                  style={{ cursor: "pointer", paddingRight: "10px" }}
                  className="password_color"
                >
                  {showPassword ? <MaskIcon src={eyeOpen} className="imageOpen" alt="" /> : <MaskIcon src={eyeClose} className="imageClose" alt="" />}
                </span>
              </div>
            </div>

            {/* Confirm Password Field */}
            <div className="form-group mt-4">
              <label style={{ color: '#8F0D3d' }} className="form-label f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                Confirm Password
              </label>
              <div className="login-input">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm password"
                  value={confirmPassword}
                  className="placholdercolorchanges"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span
                  onClick={toggleConfirmPassword}
                  style={{ cursor: "pointer", paddingRight: "10px" }}
                  className="password_color"
                >
                  {showConfirmPassword ? <MaskIcon src={eyeOpen} className="imageOpen" alt="" /> : <MaskIcon src={eyeClose} className="imageClose" alt="" />}
                </span>
              </div>
            </div>

            {/* Submit Button */}
            {/* <button
              type="submit"
              disabled={isLoading}
              style={{ backgroundColor: !isFormValid ? '#c885b1' : '#841E60', }}
              className="login-btn f3 mt-4 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18"
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </>
              ) : (
                "Confirm"
              )}

            </button> */}
            <SubmitButton
              onClick={handleConfirm}
              title="Confirm"
              className='mt-4'
              disabled={!isFormValid || isLoading}
              isFormValid={!isFormValid}
              loading={isLoading}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreatePassword;
